import { NgModule, ErrorHandler, APP_INITIALIZER, Injector, ApplicationRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule, NgbModal, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule} from '@angular/forms';
import { Http, HttpModule, XHRBackend, RequestOptions } from '@angular/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { NgbdModalComponent } from './modal-component';
import { AppConfig } from './config/app.config';
import { AppComponent } from './app.component';
import { Authentication } from './authentication/authentication';
import { LoginComponent } from './login/login.component';
import { MenuComponent } from './menu/menu.component';
import { GlobalHttpOptions } from './global-http-options';
import { GlobalHttpHandler } from './global-http-handler';
import { ImageLibraryComponent } from './image-library/image-library.component';
import { AppRoutingModule } from './app-routing.module';
import { ConfirmComponent } from './dialogboxes/confirm.component';
import { ButtonBarComponent } from './guicomponents/buttonbar/buttonbar.component';
import { GpisErrorHandler } from './errorhandler/gpiserror-handler';
import { ErrorHandlerService } from './errorhandler/gpiserror-handler.service';
import { ChipsModule, DataTableModule, SharedModule } from 'primeng/primeng';
import { PackagingCodeComponent } from './packaging-code/packaging-code.component';
import { DistributionUnitComponent } from './distribution-unit/distribution-unit.component';
import { PackagingMaterialComponent } from './packaging-material/packaging-material.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PackagingCodeSearchDlgComponent } from './packaging-code/search-packaging-code.component';
import { PackagingMaterialSearchDlgComponent } from './packaging-material/search-packaging-material.component';
import { PackagingSearchComponent } from './packaging-instruction-search/packaging-instruction-search.component';
import { PackagingMaterialSearchComponent } from './packaging-material-search/packaging-material-search.component';
import { DistributionUnitSearchComponent } from './distribution-unit-search/distribution-unit-search.component';
import { PackagingMaterialAttributeComponent } from './packaging-material-attributes/packaging-material-attributes.component';
import { SupplierContactComponent } from './supplier-contact/supplier-contact.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { MultiPartComponent } from './multipart-part/multipart-part.component';
import { PartSearchComponent } from './part-search/part-search.component';
import { ListPackagingInstructionMaterialComponent } from './packaging-instruction/list-packaging-instruction-material.component';
import { PackagingInstructionMaterialComponent } from './packaging-instruction/packaging-instruction-material.component';
import { SupplierMassMailComponent } from './supplier-mass-mail/supplier-mass-mail.component';
import { WamLoginComponent } from './login/wam-login.component';
import { PackagingInstructionComponent } from './packaging-instruction/packaging-instruction.component';
import { PackagingInstructionSelectListComponent } from './packaging-instruction/packaging-instruction-selectlist.component';
import { ChangeIssuerComponent } from './change-issuer/change-issuer.component';
import { HttpClientModule } from '@angular/common/http';
import { AuthenticationWamComponent } from './authentication-wam/authentication-wam.component';
import { AuthenticationWamService } from './authentication-wam/authentication-wam.service';
import { UserService } from './authentication-wam/user.service';
import { HomeComponent } from './home/home/home.component';
import { SequenceInstructionComponent } from './sequence-instruction/sequence-instruction.component';
import { AddMultiplePartsComponent } from './add-multiple-parts/add-multiple-parts.component';
import { MultiPartSearchComponent } from './part-search/multi-part-search.component';
import { ChineseChangeValueService } from './chinese-change-value.service';
import { ImageWarningBeforeUploadComponent } from './image-warning-before-upload/image-warning-before-upload.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { NorolepageComponent } from './norolepage/norolepage.component';
import { NorolechinapageComponent } from './norolechinapage/norolechinapage.component';


export function configFactory(config: AppConfig) {
  return () => config.load();
}

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule.forRoot(),
        HttpModule,
        AppRoutingModule,
        ChipsModule,
        DataTableModule,
        SharedModule,
        ToastModule.forRoot(),
        HttpClientModule
    ],
    declarations: [
        PackagingMaterialSearchDlgComponent,
        DistributionUnitSearchComponent,
        PackagingCodeSearchDlgComponent,
        PackagingMaterialSearchComponent,
        PackagingSearchComponent,
        AppComponent,
        LoginComponent,
        MenuComponent,
        DashboardComponent,
        ImageLibraryComponent,
        ConfirmComponent,
        ButtonBarComponent,
        PackagingCodeComponent,
        DistributionUnitComponent,
        PackagingMaterialComponent,
        PackagingMaterialAttributeComponent,
        SupplierContactComponent,
        NgbdModalComponent,
        UserManagementComponent,
        PackagingCodeComponent,
        DistributionUnitComponent,
        PackagingMaterialComponent,
        PackagingMaterialAttributeComponent,
        SupplierContactComponent,
        NgbdModalComponent,
        UserManagementComponent,
        WelcomeComponent,
        MultiPartComponent,
        WamLoginComponent,
        PartSearchComponent,
        ListPackagingInstructionMaterialComponent,
        PackagingInstructionMaterialComponent,
        SupplierMassMailComponent,
        PackagingInstructionComponent,
        PackagingInstructionSelectListComponent,
        ChangeIssuerComponent,
        AuthenticationWamComponent,
        HomeComponent,
        SequenceInstructionComponent,
        AddMultiplePartsComponent,
        MultiPartSearchComponent,
        
        ImageWarningBeforeUploadComponent,
        PrivacyComponent,
        NorolepageComponent,
        NorolechinapageComponent,
       
       
        

    ],
    providers: [
        AppConfig,
        Authentication,
        AuthenticationWamComponent,
        AuthenticationWamService,
        UserService,ChineseChangeValueService,
        ErrorHandlerService,
        { provide: APP_INITIALIZER, useFactory: configFactory, deps: [AppConfig], multi: true },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: ErrorHandler, useClass: GpisErrorHandler, deps: [ErrorHandlerService] },
        { provide: RequestOptions, useClass: GlobalHttpOptions,  }
    ],
    entryComponents: [ImageWarningBeforeUploadComponent],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/app.module.ts